import { Get } from "services/apiService";
import { BASE_URL, GET_LOCATION_ID, SOMS_API_KEY } from "services/CONSTANTS";
import { CLEAR_LOCATION_REQUEST, GET_LOCATION_ERROR, GET_LOCATION_REQUEST, GET_LOCATION_SUCCESS } from "./action-type";

export const Getlocations = () => {
    return (dispatch) => {
        dispatch(locationRequest());
        const request = {
            url: `${BASE_URL}${GET_LOCATION_ID}?apikey=${SOMS_API_KEY}`
        }
        Get(request)
            .then((response) => {
                if (response.status === 200)
                    dispatch(locationSuccess(response));
                else
                    dispatch(locationError(response));
            })
            .catch((err) => {
                dispatch(locationError(err));
            });

    };
};


export const locationSuccess = (response) => {
    const sortedLocations = response.data.locations.sort((a, b) => a.locationId - b.locationId);
    return {
        type: GET_LOCATION_SUCCESS,
        locationResponse: sortedLocations,
        islocationError: false,
        islocationSuccess: true
    }
};


export const locationRequest = () => {
    return {
        type: GET_LOCATION_REQUEST
    }
};

export const locationError = (error) => {
    return {
        type: GET_LOCATION_ERROR,
        locationResponse: error,
        islocationError: true,
        islocationSuccess: false
    }
};

export const clearLocations = () => {
    return {
        type: CLEAR_LOCATION_REQUEST
    }
}